import { keys } from './keys';

export const en = {
  [keys.banner.title]: 'Cookies',
};
